import LocalizedLink from "../../hoc/LocalizedLink"
import Paper from "../Assets/Paper/Paper"
import { IServiceOrder } from "../../types/orderTypes"
import { useTranslation } from "react-i18next"
import styles from "./OrderLayout.module.scss"

const OrderLayoutHeader = ({ order }: { order: IServiceOrder }) => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })

  return (
    <Paper className={styles.header}>
      <h2 className={styles.headerTitle}>
        {t("theRequest")} #{order.number} {t("successSubmitted")}
      </h2>
      <p className={styles.headerDescription}>{t("requestSentToEmployee")}</p>
      <LocalizedLink to={`/`} className={styles.headerBtn}>
        {t("toMain")}
      </LocalizedLink>
    </Paper>
  )
}

export default OrderLayoutHeader
